import React from "react";

const CalendarRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.75 6.75C2.75 5.64543 3.64543 4.75 4.75 4.75H15.25C16.3546 4.75 17.25 5.64543 17.25 6.75V15.25C17.25 16.3546 16.3546 17.25 15.25 17.25H4.75C3.64543 17.25 2.75 16.3546 2.75 15.25V6.75Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 2.75V6.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 2.75V6.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CalendarRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;